import React from "react"
import { Radium } from "higher-order-components"
import { titleCase, compact, compactMap, formatPhoneNumber } from "utils"
import { Hyperlink, Heading } from "components"

const fullAddress = (location) => {
  const {
    address, suburb, state, postCode
  } = location
  const region = compact([state, postCode]).join(" ")
  return compactMap(titleCase, [address, suburb])
    .concat(region || [])
    .join(", ")
}

const HoursIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4S5.4 1.6 10 1.6s8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8s-6.8 3-6.8 6.8 3 6.8 6.8 6.8c1.8 0 3.5-.7 4.8-2s2-3 2-4.8zm-5.9-.3l3.5 2.2-.9 1.5-4.4-2.7V5h1.7v4.7z" />
  </svg>
)

const AddressIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M17 7.3c0 3.1-1.6 5.5-3.3 7.6-.9 1.1-3.1 4-3.1 4l-.6.9-.7-.9s-2.2-2.9-3.1-4C4.6 12.8 3 10.4 3 7.3 3 3.4 6.2.2 10 .2s7 3.2 7 7.1zm-1.6-.1c0-3-2.4-5.4-5.4-5.4S4.6 4.3 4.6 7.2c0 2.4 1.1 4.2 2.9 6.6.6.8 1.7 2.2 2.4 3.2.7-1 1.9-2.4 2.4-3.2 2-2.3 3.1-4.2 3.1-6.6zm-3.2-.6c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2.9 2.2 2.2z" />
  </svg>
)

const WebsiteIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5-4.3-1-5.9-2.5-2.5-3.7-2.5-6 1-4.4 2.5-6 3.7-2.5 6-2.5c2.2 0 4.4.9 6 2.5s2.4 3.8 2.4 6zM3.3 9.1h2.8c0-1.8.4-3.5.9-4.8.1-.2.2-.3.2-.5-.8.3-1.4.8-2 1.4-1.1 1.1-1.7 2.5-1.9 3.9zm1.9 5.7c.6.6 1.3 1.1 2 1.4 0-.2-.1-.3-.2-.5-.5-1.3-.9-3-.9-4.8H3.3c.2 1.4.8 2.8 1.9 3.9zM10 3.2c-.3 0-.9.5-1.4 1.7-.4 1.2-.7 2.6-.8 4.2h4.4c-.1-1.6-.4-3.1-.8-4.2 0-.1-.1-.1-.1-.2.8.2 1.5.6 2.2 1.1.2 1 .4 2.1.5 3.3h2.8c-.2-1.5-.8-2.9-1.9-3.9-1.4-1.3-3.1-2-4.9-2zm1.4 11.9c.5-1.1.7-2.6.8-4.2H7.8c.1 1.6.4 3.1.8 4.2.5 1.3 1.1 1.7 1.4 1.7s.9-.5 1.4-1.7zm5.3-4.2h-2.8c-.1 1.8-.4 3.5-.9 4.8-.1.2-.2.4-.2.5.8-.3 1.4-.8 2-1.4 1.1-1.1 1.7-2.5 1.9-3.9z" />
  </svg>
)

const PhoneIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M1.4 14.7c-.3-.9 0-1.5.9-1.9.6-.3 1.5-.7 2.2-1 .5-.2 1-.5 1.4-.6.2-.1.4-.2.7-.2.5 0 .9.4 1 .5l.9.9c.5-.3 1.4-.9 2.2-1.7s1.4-1.7 1.7-2.2l-.9-.9c-.7-.6-.6-1.2-.3-1.8.2-.4.4-.8.6-1.4.3-.7.7-1.6 1-2.2.1-.3.4-1 1.2-1 .2 0 .4.1.6.1 2 .6 4 2.1 4 4.2 0 2-1.6 5.7-4.6 8.6-3 3-6.6 4.6-8.6 4.6-1.9.1-3.5-2-4-4zm1.5-.4c.4 1.4 1.5 2.9 2.6 2.9 1.4 0 4.7-1.3 7.6-4.1 2.8-2.8 4.1-6.1 4.1-7.6 0-1.1-1.5-2.2-2.9-2.6-.3.6-.7 1.5-1 2.2-.2.5-.5 1-.6 1.3v.1l1.7 1.7-.2.5c0 .1-.8 1.6-2.3 3.1-1.5 1.5-3 2.2-3.1 2.3l-.5.2-1.7-1.7h-.1c-.3.2-.8.4-1.3.6-.9.4-1.7.8-2.3 1.1z" />
  </svg>
)

const InfoIcon = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M18.4 10c0 2.2-.9 4.4-2.5 6s-3.7 2.5-6 2.5c-4.6 0-8.4-3.8-8.4-8.4 0-2.2.9-4.4 2.5-6s3.7-2.5 6-2.5c4.6 0 8.4 3.8 8.4 8.4zm-1.6 0c0-3.7-3-6.8-6.8-6.8-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 3.7 3 6.8 6.8 6.8 1.8 0 3.5-.7 4.8-2s2-3 2-4.8zM9.1 5.7h1.7v1.7H9.1V5.7zm0 2.8h1.7v5.8H9.1V8.5z" />
  </svg>
)

const Icon = ({ name }) => {
  const style = {
    height: "1.3em",
    width: "1.3em",
    marginRight: "1em",
    fill: "#999999",
    flexShrink: 0
  }
  switch (name) {
  case "hours":
    return <HoursIcon style={style} />
  case "address":
    return <AddressIcon style={style} />
  case "website":
    return <WebsiteIcon style={style} />
  case "phone":
    return <PhoneIcon style={style} />
  case "info":
    return <InfoIcon style={style} />
  }
}


class DealerDetails extends React.PureComponent {
  render() {
    const { location, type, gtmEvents } = this.props
    const department = location.departments.find(department => department.name.toLowerCase() === type)
    const asAbsolute = (url) => {
      if (
        url.slice(0, "http://".length) === "http://" ||
                url.slice(0, "https://".length) === "https://"
      ) {
        return url
      }
      return `http://${url}`
    }

    return (
      <div style={{ marginBottom: "2em" }}>
        <Heading value={location.name} tag={"h5"} />
        <ul style={{ padding: 0, margin: "1em 0", listStyleType: "none" }}>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <Icon name="address" />
            <div>
              <Hyperlink
                text={fullAddress(this.props.location)}
                href={`https://google.com.au/maps?q=${fullAddress(this.props.location).replace(/ /g, "+")}/`}
                external
                gtmEvents={[
                  {
                    func: gtmEvents[0].func,
                    args: [
                      {
                        gtmID: gtmEvents[0].args[0].gtmID,
                        gtmPayload: {
                          dealerName: location.name,
                          address: fullAddress(this.props.location)
                        }
                      }
                    ]
                  }
                ]} />
            </div>
          </li>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <Icon name="hours" />
            <div>
              <strong>Opening hours:</strong>
              {department.hours.map((label, index) => <div key={index}>{label}</div>)}
            </div>
          </li>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <Icon name="website" />
            <div>
              <Hyperlink
                text={location.websiteLabel}
                href={asAbsolute(location.website)}
                external
                gtmEvents={[
                  {
                    func: gtmEvents[1].func,
                    args: [
                      {
                        gtmID: gtmEvents[1].args[0].gtmID,
                        gtmPayload: {
                          dealerName: location.name,
                          address: fullAddress(this.props.location),
                          website: location.websiteLabel
                        }
                      }
                    ]
                  }
                ]} />
            </div>
          </li>
          <li style={[dealerDetailStyles.detailItem, dealerDetailStyles.fadeIn]}>
            <Icon name="phone" />
            <div>
              {this.props.compact &&
              <Hyperlink
                text={department.phoneLabel}
                href={`tel:${department.phone}`}
                gtmEvents={[
                  {
                    func: gtmEvents[2].func,
                    args: [
                      {
                        gtmID: gtmEvents[2].args[0].gtmID,
                        gtmPayload: {
                          dealerName: location.name,
                          address: fullAddress(this.props.location),
                          phone: department.phone
                        }
                      }
                    ]
                  }
                ]} />
              }
              {!this.props.compact && <span>{formatPhoneNumber(department.phoneLabel)}</span>}
            </div>
          </li>
        </ul>
      </div>
    )
  }
}
export default Radium(DealerDetails)


const dealerDetailStyles = {
  detailItem: {
    display: "flex",
    fontWeight: 200,
    margin: ".5em 0",
    lineHeight: "1.4"
  }
}



// WEBPACK FOOTER //
// ./src/components/form-elements/dealers-field/dealer-details.js